/* eslint-disable no-underscore-dangle */
import PouchDB from 'pouchdb';
import { get } from '../utils/api';
import { upsert } from './common';
import endpoints from '../endpoints';

const CUSTOMER_ADDRESSES = 'XXSCustomerAddresses';

class CustomerAddressesStore {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  save = (response, onSuccess) => {
    upsert(this.db, CUSTOMER_ADDRESSES, response.data, onSuccess);
  };

  fetchAndSave = (onSuccess) => get(endpoints.customerAddresses.get).then((response) => this.save(response, onSuccess));

  load = (callback) => {
    this.db
      .get(CUSTOMER_ADDRESSES)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };
}

export default CustomerAddressesStore;
